import { Box, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import colors from '../../../assets/colors'
import { fetchSignatureStatus } from '../../subscription/SubscriptionActions'
import { renderRouteRole } from '../../../util/utils'

import LaundrySubscriptionStatus from './LaundrySubscriptionStatus'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    height: '32px',
    padding: '0 12px',
    borderRadius: '8px',
    background: colors.primary,
    color: '#FFF',
    fontSize: '13px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    transition: 'opacity .2s ease-in-out',
    '&:hover': {
      opacity: 0.9,
    },
  },
  dot: {
    width: '8px',
    height: '8px',
    flexShrink: 0,
    borderRadius: '50%',
  },
  alert: {
    background: colors.error,
    boxShadow: `0 0 0 3px ${colors.bgError}`,
    animation: '$pulse 2s ease-in-out infinite',
  },
  warning: {
    background: colors.info,
    boxShadow: `0 0 0 3px ${colors.bgInfo}`,
  },
  ok: {
    background: colors.sucess,
    boxShadow: `0 0 0 3px ${colors.bgSucess}`,
  },
  pill: {
    display: 'flex',
    alignItems: 'center',
    height: '22px',
    padding: '0 8px',
    borderRadius: '6px',
    background: colors.error,
    color: '#FFF',
    fontSize: '12px',
  },
  '@keyframes pulse': {
    '0%, 100%': { boxShadow: `0 0 0 3px ${colors.bgError}` },
    '50%': { boxShadow: `0 0 0 5px ${colors.bgError}` },
  },
})

const SIGNATURE_OK_ID = 20

const Alert = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const roles = useSelector(state => state.auth.role)

  const subscriptionStatus = useSelector(
    state => state.subscription.subscriptionStatus
  )

  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(!open)
  }

  useEffect(() => {
    if (!roles?.length) return
    if (renderRouteRole(['administrador'], roles)) return

    dispatch(fetchSignatureStatus())
  }, [roles])

  const {
    laundry_status: laundryStatusRaw,
    trial_days_to_expire: daysToExpire,
    subscription_status_id: signatureStatusIdRaw,
  } = subscriptionStatus || {}

  const laundryStatus = Number(laundryStatusRaw)

  if (![1, 2, 3].includes(laundryStatus)) return null

  const isAlert = [2, 3].includes(laundryStatus)
  const hasPending = Number(signatureStatusIdRaw) !== SIGNATURE_OK_ID

  // status 2/3 -> vermelho | status 1 com pendência -> amarelo | status 1 ok -> verde
  let variant = classes.ok
  if (isAlert) variant = classes.alert
  else if (hasPending) variant = classes.warning

  const isOk = !isAlert && !hasPending

  return (
    <>
      <Box className={classes.root} onClick={handleOpen}>
        <span className={`${classes.dot} ${variant}`} />

        {isOk ? (
          <>
            <Typography variant="inherit">Assinatura ativa</Typography>
          </>
        ) : (
          <>
            {laundryStatus === 2 && (
              <Typography variant="inherit">
                Seu período de teste acaba em - {daysToExpire} dia(s)
              </Typography>
            )}

            {laundryStatus === 3 && (
              <Typography variant="inherit">
                Seu período de teste expirou
              </Typography>
            )}

            {laundryStatus == 1 && signatureStatusIdRaw == 30 && (
              <Typography variant="inherit">Pendência na assinatura</Typography>
            )}

            {isAlert && <Box className={classes.pill}>Assinar agora</Box>}
          </>
        )}
      </Box>

      <LaundrySubscriptionStatus
        open={open}
        handleOpen={handleOpen}
        status={subscriptionStatus}
        isOk={isOk}
      />
    </>
  )
}

export default Alert
